import { render } from "./AddChapter.vue?vue&type=template&id=f69c570e"
import script from "./AddChapter.vue?vue&type=script&lang=js"
export * from "./AddChapter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__